import ReactGA4 from "react-ga4";
import { v4 as uuidv4 } from 'uuid';
const getUserId = () => {
  let userId = localStorage.getItem("userId");
  if (!userId) {
    userId = uuidv4(); // Create a unique ID if new user
    localStorage.setItem("userId", userId);
  }
  return userId;
};

// const InitializeGoogleAnalytics = () => {
  
//     const userId = getUserId();
//     ReactGA4.initialize("G-B84KD79XTF");
//     // ReactGA4.set({ user_id: userId });
//     // console.log("GA4 INITIALIZED");
 
// };

// const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// const InitializeGoogleAnalytics = () => {
//   if (!GA_TRACKING_ID) {
//     console.warn("Google Analytics tracking ID is missing!");
//     return;
//   }

//   const userId = getUserId();
//   ReactGA4.initialize(GA_TRACKING_ID);
//   // ReactGA4.set({ user_id: userId });
//   //console.log("GA4 INITIALIZED with ID:", GA_TRACKING_ID);
// };


// const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// const InitializeGoogleAnalytics = () => {
//   const currentPath = window.location.pathname;

//   // Skip GA initialization for /homebuyingtips
//   if (currentPath === "/homebuyingtips") {
//     console.log("GA4 not initialized for /homebuyingtips");
//     return;
//   }

//   if (!GA_TRACKING_ID) {
//     console.log("Google Analytics tracking ID is missing!");
//     return;
//   }

//   const userId = getUserId();

//   setTimeout(() => {
//     ReactGA4.initialize([
//       {
//         trackingId: GA_TRACKING_ID,
//         gaOptions: {
//           send_page_view: false, // disable default page_view
//         },
//       },
//     ]);
//     console.log("GA4 INITIALIZED with ID:", GA_TRACKING_ID);
//   }, 3000);

//   // ReactGA4.set({ user_id: userId });
// };


const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

const InitializeGoogleAnalytics = () => {
  if (!GA_TRACKING_ID) {
    console.warn("Google Analytics tracking ID is missing!");
    return;
  }

  const currentPath = window.location.pathname;
  const userId = getUserId();

  if (currentPath === "/homebuyingtips") {
  ReactGA4.initialize(GA_TRACKING_ID);
  } else {
    // Delayed GA initialization without default page_view
    setTimeout(() => {
      ReactGA4.initialize([
        {
          trackingId: GA_TRACKING_ID,
          gaOptions: {
            send_page_view: false, // disable default page_view
          },
        },
      ]);
    }, 3000);
  }

  // Optionally set user ID
  // ReactGA4.set({ user_id: userId });
};




// const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// const InitializeGoogleAnalytics = () => {
//   if (!GA_TRACKING_ID) {
//     console.log("Google Analytics tracking ID is missing!");
//     return;
//   }

//   const userId = getUserId();
//   // ReactGA4.initialize(GA_TRACKING_ID);
//   setTimeout(() => {
//     ReactGA4.initialize([
//   {
//     trackingId: GA_TRACKING_ID,
//     gaOptions: {
//       send_page_view: false,   // ✅ disable default page_view
//     },
//   },
  
// ]);
//  console.log("GA4 INITIALIZED with ID:", GA_TRACKING_ID);
//   }, 3000); 
//   // ReactGA4.set({ user_id: userId });
//   //console.log("GA4 INITIALIZED with ID:", GA_TRACKING_ID);
// };


function convertFirstLastToText(phoneNumber) {
  const numberWords = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];

  // Validate if input is a number (or a numeric string)
  if (!/^\d+$/.test(phoneNumber)) {
    return phoneNumber; // Return as-is if not a valid number
  }

  phoneNumber = phoneNumber.toString(); // Ensure it's a string
  if (phoneNumber.length < 2) return phoneNumber; // Handle edge cases

  let firstDigit = numberWords[parseInt(phoneNumber[0])]; // Convert first digit
  let lastDigit = numberWords[parseInt(phoneNumber[phoneNumber.length - 1])]; // Convert last digit

  // Replace first and last digits with words
  return firstDigit + phoneNumber.slice(1, -1) + lastDigit;
}

const TrackGoogleAnalyticsEvent = (
  category: string,
  action: string,
  label: string
) => {
  // console.log("GA event:", category, ":", action, ":", label);
  // Send UA Event
  //   ReactGA.event({
  //     category: category,
  //     action: action,
  //     label: label,
  //   });
  // Send GA4 Event
  label = convertFirstLastToText(label);
  if (category && action && label) {
    try {
      ReactGA4.event({
        category: category,
        action: action,
        label: label,
      });
    } catch (error) {
      console.error("Failed to send GA event:", error);
    }
  }
};

function setUserSessionSource(source, medium, campaign) {
  // Construct the session-scoped parameters
  const sessionParams = {};

  if (source) {
    sessionParams.session_source = source;
  }
  if (medium) {
    sessionParams.session_medium = medium;
  }
  if (campaign) {
    sessionParams.session_campaign = campaign;
  }

  // Send the event with the session-scoped parameters
  if (Object.keys(sessionParams).length > 0) {
    ReactGA4.event('session_start', sessionParams);
    // console.log("GA4 session source parameters set:", sessionParams); //Optional logging
  }
  //  else {
  //   console.log("No session source parameters provided."); //Optional logging
  // }
}



function CompletePurchase(phone, url) {
  // console.log("Inside CompletePurchase - Raw inputs:", phone, url);

  
  ReactGA4.event("purchase", {
    transaction_id: convertFirstLastToText(phone),
    affiliation: "Beyondwalls",
    value: 1,
    tax: 1,
    shipping: 1,
    currency: "INR",
    items: [
      {
        item_id: convertFirstLastToText(phone),
        item_name: convertFirstLastToText(phone),
        price: 1,
        quantity: 1,
        category: "lead_category",
      }
    ]
  });
}

// const sendPageView = () => {
//   // ReactGA4.send({hitType: "pageview", page: window.location.pathname});
//   console.log("GA4 PageView Sent");
// }


export function sendPageView(payload = {}) {
  const LAST_PV_KEY = "__bw_last_pv";
  const DEDUPE_WINDOW_MS = 2000; // 2s dedupe

  try {
    const page_path = payload.page_path || window.location.pathname + window.location.search;
    const page_title = payload.page_title || document.title || "";
    const page_location = payload.page_location || window.location.href;
    const page_referrer = payload.page_referrer || document.referrer || "direct";
    const label = payload.label || page_title || page_path;

    const key = `${page_path}|${page_title}`;
    const raw = sessionStorage.getItem(LAST_PV_KEY);
    if (raw) {
      try {
        const obj = JSON.parse(raw);
        if (obj && obj.key === key && (Date.now() - obj.ts) < DEDUPE_WINDOW_MS) {
          // console.debug("[sendPageView] suppressed by dedupe", key);
          return;
        }
      } catch (e) { /* ignore parse error */ }
    }

    // 1) If you have a ReactGA4 instance in this file (optional), use it.
    //    Replace `ReactGA4` with the actual var name if different.
    try {
      if (typeof ReactGA4 !== "undefined" && ReactGA4 && typeof ReactGA4.event === "function") {
        ReactGA4.event({
          category: "page_view",
          action: "page_view",
          label,
          page_path,
          page_title,
          page_location,
          page_referrer,
        });
        sessionStorage.setItem(LAST_PV_KEY, JSON.stringify({ key, ts: Date.now() }));
        // console.debug("[sendPageView] sent via ReactGA4", key);
        return;
      }
    } catch (e) {
      console.warn("[sendPageView] ReactGA4 send error", e);
    }

    // 2) gtag (gtag.js) fallback
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_title,
          page_location,
          page_path,
          page_referrer,
          label,
        });
        sessionStorage.setItem(LAST_PV_KEY, JSON.stringify({ key, ts: Date.now() }));
        // console.debug("[sendPageView] sent via gtag", key);
        return;
      }
    } catch (e) {
      console.warn("[sendPageView] gtag send error", e);
    }

    // 3) dataLayer (GTM) fallback
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: "page_view",
          page_title,
          page_location,
          page_path,
          page_referrer,
          label,
        });
        sessionStorage.setItem(LAST_PV_KEY, JSON.stringify({ key, ts: Date.now() }));
        // console.debug("[sendPageView] pushed to dataLayer", key);
        return;
      }
    } catch (e) {
      console.warn("[sendPageView] dataLayer push error", e);
    }

    // console.debug("[sendPageView] no analytics provider available", { page_path, page_title, label });
  } catch (err) {
    console.warn("[sendPageView] unexpected error", err);
  }
}


export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent, CompletePurchase , setUserSessionSource};